import Vue from "vue";
import Component from "vue-class-component";
import ABaseComponent from 'Components/Base/ABaseComponent';
import { PorterViewModel, CustomerBarcodeStatusCode } from "Api/CoreApi";
import { Prop } from "vue-property-decorator";
import ApiProvider from "Api/ApiProvider";

@Component({
    template: "#download-filters-modal-template"
})
export default class DownloadFiltersModalComponent extends ABaseComponent
{
    @Prop()
    public modalId: string;
    @Prop()
    public downloadUrl: string;
    @Prop()
    public porterNo: string;

    public porterList: PorterViewModel[] = null;
    public customerBarcodeStatusCodes: CustomerBarcodeStatusCode[] = null;
    public showPorterDropdown: boolean = false;

    isOrderMailEmpty() {
        const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var parent = this.$parent as any;
        var mail = parent.mail;
        if (mail === '' || mail == null) {
            return true;
        }
        return !re.test(String(mail).toLowerCase());
    }
    mounted() {
        const self = this;
        const client = ApiProvider.getApiClient();
        
        // get list of porters
        client.getPorterList()
            .then(result => {
                self.porterList = result.porters;
            });
        
        // get list of barcode statuscodes
        client.getCustomerBarcodeStatusCodes()
            .then(result => {
                self.customerBarcodeStatusCodes = result;
            });

        self.setLoaded();

        $('.porters-select').select2();

        // resets form on closed fancybox
        $('[data-fancybox]').fancybox({
            'afterClose': function (instance, current) {
                // resets form
                $(current.src).find('form').trigger('reset');

                // reset porters dropdown
                $('.porters-select').val(null).trigger('change');

                self.showPorterDropdown = false;
            }
        });
    }

    async togglePorterFilter() {
        this.showPorterDropdown = true;
    }

    async download(submitEvent: any) {
        try {
            var parent = this.$parent as any;
            var mail = parent.mail;
            var data = $(submitEvent.target).serialize();

            var url = this.downloadUrl + "&" + data + `&from=${this.lastYear.toISOString().substring(0, 10)}&to=${new Date().toISOString().substring(0, 10)}&email=${mail}`;
            //Call endpoint to request download, a mail will be sent from ERP
            $.get(url).then((returnVal, statusText, xhr) => {
                this.$parent.$emit("show-download-message", xhr.status);
            });           
            $.fancybox.close();
        } catch (e) {
            this.setError(e);
        }

        this.setLoaded();
    }

    get lastYear() {
        let thisYear = new Date();
        thisYear.setFullYear(thisYear.getFullYear() - 1);
        return thisYear;
    }
}




Vue.component('download-filters-modal', DownloadFiltersModalComponent);